import {NyModal} from 'nyse-web-tools-common/lib/react';
import connect from 'nyse-web-tools-common/lib/utils/redux.connect';
import PropTypes from 'prop-types';
import React, {useEffect, useRef, useState} from 'react';

import {deleteSymbolMpidClearing} from '../../../stores/symbolMpidClearing/symbolMpidClearing.actions';

const DeleteConfirmationModalComponent = (props) => {
    const {
        userCrd,
        selectedRows,
        show,
        hideModal,
        onClose,
        deleteSymbolMpidClearing,
        symbolMpidClearing
    } = props;

    const isMountedRef = useRef(false);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const isDeleting = symbolMpidClearing.isDeleting;

    const onConfirmDelete = async () => {
        const configurations = selectedRows.map((row) => ({
            mpid: row.mpid,
            symbol: row.symbol,
            clearingNumber: row.clearingNumber
        }));

        try {
            const action = await deleteSymbolMpidClearing({userCrd, configurations});
            // Extract success message from API response
            const successMessage = action?.payload?.data?.data || 'Symbol MPID clearing configuration(s) deleted successfully';

            // Delay closing to allow any state updates to complete
            setTimeout(() => {
                if (isMountedRef.current) {
                    onClose(true, successMessage);
                }
            }, 0);
        } catch (error) {
            if (isMountedRef.current) {
                setErrorMessage(error.message || 'Failed to delete configurations. Please try again.');
            }
        }
    };

    return (
        <NyModal
            show={show}
            hideModal={hideModal}
            title='Confirm Delete'
            className='modal-medium'>
            <div className='modal-body'>
                <p className='space-bottom-1'>
                    Are you sure you want to delete <strong>{selectedRows.length}</strong> mapping{selectedRows.length !== 1 ? 's' : ''}?
                </p>

                {errorMessage && (
                    <div className='alert alert-danger space-bottom-1'>
                        {errorMessage}
                    </div>
                )}
            </div>

            <div className='modal-footer'>
                <button
                    className='btn btn-danger'
                    onClick={onConfirmDelete}
                    disabled={isDeleting}>
                    {isDeleting ? 'Deleting...' : 'Confirm Delete'}
                </button>
                <button
                    className='btn btn-default'
                    onClick={() => onClose(false)}
                    disabled={isDeleting}>
                    Cancel
                </button>
            </div>
        </NyModal>
    );
};

DeleteConfirmationModalComponent.propTypes = {
    userCrd: PropTypes.number.isRequired,
    selectedRows: PropTypes.arrayOf(PropTypes.shape({
        mpid: PropTypes.string.isRequired,
        symbol: PropTypes.string.isRequired,
        clearingNumber: PropTypes.string.isRequired
    })).isRequired,
    show: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    deleteSymbolMpidClearing: PropTypes.func.isRequired,
    symbolMpidClearing: PropTypes.shape({
        isDeleting: PropTypes.bool,
        deleteError: PropTypes.object
    })
};

export const DeleteConfirmationModal = connect(
    ['symbolMpidClearing'],
    {deleteSymbolMpidClearing}
)(DeleteConfirmationModalComponent);
